import { httpRequest } from './http';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const profileApi = {
  // Get current user profile
  getProfile: async () => {
    try {
      const response = await httpRequest(API_BASE_URL, '/api/v1/profile', {
        method: 'GET',
        credentials: 'include',
      });
      return response;
    } catch (error) {
      console.error('Profile fetch error:', error);
      throw error;
    }
  },

  // Update user profile
  updateProfile: async (profileData) => {
    try {
      const response = await httpRequest(API_BASE_URL, '/api/v1/profile', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(profileData),
      });
      return response;
    } catch (error) {
      console.error('Profile update error:', error);
      throw error;
    }
  },

  // Update password
  updatePassword: async (passwordData) => {
    try {
      const response = await httpRequest(API_BASE_URL, '/api/v1/profile/password', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(passwordData),
      });
      return response;
    } catch (error) {
      console.error('Password update error:', error);
      throw error;
    }
  },
};
